import {
    GET_CONFIG
} from "@/constant/actions";
import SchoolConfigService from "@/services/SchoolService/SchoolConfigService";

export const schoolConfigStore = {
    namespaced: true,
    state: {
        configData: {
            statusPrint: undefined,
            statusShowDateTime: undefined,
            printType: undefined,
        },

    },
    mutations: {
        [GET_CONFIG](state, schoolConfig) {
            state.configData.statusPrint = schoolConfig.data.statusPrint;
            state.configData.statusShowDateTime = schoolConfig.data.statusShowDateTime;
            state.configData.printType = schoolConfig.data.printType;
        },
    },
    actions: {
        [GET_CONFIG]({commit}) {
            return SchoolConfigService.getConfigPrintOrder()
                .then((res) => {
                    if (res) {
                        commit(GET_CONFIG, {data: res.data});
                    }
                })
        },

    },
};
